// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Fechamentos_ShowResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for show() /fechamentos/show
 * Returns a single fechamento record with enriched data and plano de contas snapshot
 */
import type { Fechamentos_PlanoContaSnapshotRow } from './Fechamentos_PlanoContaSnapshotRow'
import type { Fechamentos_PlanoContaTotaisRow } from './Fechamentos_PlanoContaTotaisRow'
import type { Fechamentos_SummaryRow } from './Fechamentos_SummaryRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Fechamentos_ShowResponseDados {
plano_contas: Fechamentos_PlanoContaSnapshotRow[]
id?: number
franquia_id?: number
data_inicial?: string
data_final?: string
meta_faturamento?: number
meta_clientes?: number
meta_itens?: number
status?: string
valor_realizado?: number
numero_clientes?: number
faturamento_vendas_realizadas?: number
total_recebimentos_conferidos?: number
total_recebido_dinheiro?: number
total_despesas_pagas?: number
lucro_mensal?: number
registro_mes_inauguracao?: number
conferido_pelo_franqueado?: number
total_recebimentos_disponiveis?: number
caixa_mensal?: number
previsao_marketing?: number
previsao_insumos?: number
previsao_impostos?: number
previsao_taxas_cobranca?: number
total_previsto_folha_pagamento?: number
data_fechamento?: string
usuario_fechamento_id?: string
data_reabertura?: string
usuario_reabertura_id?: string
motivo_reabertura?: string
created_at?: string
updated_at?: string
deleted_at?: string
periodo_formatado?: string
resumo?: Fechamentos_SummaryRow
totais_plano?: Fechamentos_PlanoContaTotaisRow
}

export type Fechamentos_ShowResponse = ApiResponse<Fechamentos_ShowResponseDados>;

registerResponseContract('Fechamentos_ShowResponse', {
  plano_contas: {
    type: 'array',
    required: true,
    items: {
      id:                      { type: 'number',  required: false },
      fechamento_id:           { type: 'number',  required: false },
      categoria_id:            { type: 'number',  required: false },
      nome_conta_snapshot:     { type: 'string',  required: false },
      tipo_snapshot:           { type: 'string',  required: false },
      percentual_snapshot:     { type: 'string',  required: false },
      valor_previsto_snapshot: { type: 'string',  required: false },
      created_at:              { type: 'string',  required: false },
      valor_efetivo:           { type: 'string',  required: false },
      variacao_percentual:     { type: 'number',  required: false },
      variacao_valor:          { type: 'number',  required: false },
      variance_status:         { type: 'string',  required: false },
      variance_icon:           { type: 'string',  required: false },
    },
  },
  id:                             { type: 'number',  required: false },
  franquia_id:                    { type: 'number',  required: false },
  data_inicial:                   { type: 'string',  required: false },
  data_final:                     { type: 'string',  required: false },
  meta_faturamento:               { type: 'number',  required: false },
  meta_clientes:                  { type: 'number',  required: false },
  meta_itens:                     { type: 'number',  required: false },
  status:                         { type: 'string',  required: false },
  valor_realizado:                { type: 'number',  required: false },
  numero_clientes:                { type: 'number',  required: false },
  faturamento_vendas_realizadas:  { type: 'number',  required: false },
  total_recebimentos_conferidos:  { type: 'number',  required: false },
  total_recebido_dinheiro:        { type: 'number',  required: false },
  total_despesas_pagas:           { type: 'number',  required: false },
  lucro_mensal:                   { type: 'number',  required: false },
  registro_mes_inauguracao:       { type: 'number',  required: false },
  conferido_pelo_franqueado:      { type: 'number',  required: false },
  total_recebimentos_disponiveis: { type: 'number',  required: false },
  caixa_mensal:                   { type: 'number',  required: false },
  previsao_marketing:             { type: 'number',  required: false },
  previsao_insumos:               { type: 'number',  required: false },
  previsao_impostos:              { type: 'number',  required: false },
  previsao_taxas_cobranca:        { type: 'number',  required: false },
  total_previsto_folha_pagamento: { type: 'number',  required: false },
  data_fechamento:                { type: 'string',  required: false },
  usuario_fechamento_id:          { type: 'string',  required: false },
  data_reabertura:                { type: 'string',  required: false },
  usuario_reabertura_id:          { type: 'string',  required: false },
  motivo_reabertura:              { type: 'string',  required: false },
  created_at:                     { type: 'string',  required: false },
  updated_at:                     { type: 'string',  required: false },
  deleted_at:                     { type: 'string',  required: false },
  periodo_formatado:              { type: 'string',  required: false },
  resumo: {
    type: 'object',
    required: false,
    fields: {
      meta_faturamento:    { type: 'number',  required: true },
      meta_clientes:       { type: 'number',  required: false },
      total_previsto:      { type: 'number',  required: true },
      total_efetivo:       { type: 'number',  required: true },
      valor_realizado:     { type: 'number',  required: true },
      variacao_percentual: { type: 'number',  required: false },
      total_despesas:      { type: 'number',  required: true },
      lucro_liquido:       { type: 'number',  required: true },
      status:              { type: 'string',  required: true },
      periodo:             { type: 'string',  required: true },
    },
  },
  totais_plano: {
    type: 'object',
    required: false,
    fields: {
      total_previsto:      { type: 'number',  required: true },
      total_efetivo:       { type: 'number',  required: true },
      variacao_percentual: { type: 'number',  required: false },
      num_contas:          { type: 'number',  required: true },
    },
  },
})
